// extracted by mini-css-extract-plugin
export default {"div":"Footer_div__4RApz","social":"Footer_social__WSX7i","icon":"Footer_icon__jJxan","fot":"Footer_fot__Ex4Dv"};